import { FileObjectType } from "@jsq/ds/core";
import { BaseDocumentType } from "../../../graphql/supergraph.index";

/**
 * Document sub type enum, these are strings that are used to identify the type of document
 */
export enum DocumentSubTypeEnum {
  ArticlesOfIncorporation = "articles_of_incorporation",
  LimitedPartnership = "limited_partnership",
  CertificateOfFormation = "certificate_of_formation",
  CertificateOfIncorporation = "certificate_of_incorporation",
  CertificateOfFormOrPartnership = "certificate_of_form_or_partnership",
}

/**
 * Document sub type type, these are strings that are used to identify the type of document
 */
export type DocumentSubType =
  | "articles_of_incorporation"
  | "limited_partnership"
  | "certificate_of_formation"
  | "certificate_of_incorporation"
  | "certificate_of_form_or_partnership";

/**
 * These are the data that are used to display the document category info
 */
export type DocumentData = {
  id?: number;
  file: FileObjectType | null;
  uploaderInfo?: string | null;
  baseType: BaseDocumentType;
  subType: string | null;
  meta?: { profileId: number | undefined };
};

/**
 * Strings that are used to display the document category info
 */
export type DocumentCategoryInfo = {
  title: string;
  description: string;
};

/**
 * Document form props type, these are the data that are used to display the document category info
 */
export type DocumentFormProps = DocumentCategoryInfo & DocumentData;

export type DocumentInvitedUserInfo = {
  emailAddress: string;
  id: number;
};

export interface DocumentCollectorProps {
  /**
   * Identification document category
   */
  documentDetails: DocumentFormProps[];

  isSubmitting: boolean;

  buttonConfig?: {
    label: string;
    showNoDocumentsTT?: boolean;
  };

  /**
   * Handler for back button click
   */
  onNavigateBack?: () => void;

  /**
   * Handler for complete button click
   */
  onComplete: (replacedFiles: DocumentData[], newUploadFiles: DocumentData[]) => void;
}
